import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import SearchResult from "@/components/SearchResult";
import { SearchResultPageTitle } from "@/constants";

const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({
  locale = "en",
  params = {},
  plpData = {},
  facetLabelsState = {},
  search = "",
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  const { type, ...rest } = router.query;
  const transitionKey = router.pathname + JSON.stringify(rest);
  const slugKey =
    search ||
    (Array.isArray(params?.params)
      ? params.params.join("/")
      : params?.params || "");
  const pageTitle = `${slugKey} ${SearchResultPageTitle}`;
  return (
    <>
      <Head>
        <title>{`${pageTitle}`}</title>
      </Head>
      <SearchResult
        key={transitionKey}
        locale={locale}
        params={params}
        search={search}
      />
    </>
  );
};

export async function getServerSideProps({ req, params, preview, query }) {
  const { search = "" } = query;
  const {
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
  } = await getPageShellDataSafely({
    slug: `/results`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: false,
  });

  return {
    props: {
      //   pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      search,
      params,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  plpData: PropTypes.object,
  facetLabelsState: PropTypes.object,
  categoryConfig: PropTypes.string,
  params: PropTypes.object,
};

export default LandingPage;
